import { IconType } from "react-icons/lib";
import { TbCar, TbChecks, TbClock, TbHeartHandshake } from "react-icons/tb";

import { softColors } from "./colors";
import { PASSENGER_STATUS } from "./status";

export interface PassengerStatusComp {
    status: PASSENGER_STATUS;
    component: () => IconType;
    bg: string;
    text: string;
    hover: string;
    index: number;
    statuses: PASSENGER_STATUS[];
}
export const passengerStatuses: PassengerStatusComp[] = [
    {
        status: PASSENGER_STATUS.PENDING,
        index: 0,
        component: () => TbClock,
        ...softColors.indigo,
        statuses: [PASSENGER_STATUS.PENDING],
    },
    {
        status: PASSENGER_STATUS.WAITING,
        component: () => TbHeartHandshake,
        index: 1,
        ...softColors.green,
        statuses: [PASSENGER_STATUS.WAITING, PASSENGER_STATUS.DONE, PASSENGER_STATUS.PICKED_UP],
    },
    {
        status: PASSENGER_STATUS.PICKED_UP,
        component: () => TbCar,
        index: 2,
        ...softColors.blue,
        statuses: [],
    },
    {
        status: PASSENGER_STATUS.DONE,
        component: () => TbChecks,
        index: 3,
        ...softColors.green,
        statuses: [],
    },
];

export const planPassengerStatuses: PassengerStatusComp[] = passengerStatuses.map((item) =>
    item.status === PASSENGER_STATUS.WAITING ? { ...item, ...softColors.purple } : item
);
export const passengerStatusOptions: { label: string; value: string }[] = passengerStatuses.map((item) => ({
    label: item.status,
    value: item.status,
}));
